// Meta Pixel integration via direct fbq script injection.
// Avoids dependency on a specific npm wrapper's API.

const PIXEL_ID = '2418833905303854'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

function loadFbqScript() {
  if (typeof window === 'undefined') return
  if (window.fbq)
    return // Standard Meta Pixel base code (rewritten in TS-friendly form)
    /* eslint-disable */
  ;(function (f: any, b, e, v, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )
  /* eslint-enable */
}

export function initPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return
  try {
    loadFbqScript()
    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
    initialized = true
  } catch (err) {
    console.warn('Meta Pixel init failed', err)
  }
}

export function trackEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  try {
    if (!initialized) initPixel()
    window.fbq?.('track', event, params)
  } catch (err) {
    console.warn(`Meta Pixel track(${event}) failed`, err)
  }
}

export function trackPageView() {
  trackEvent('PageView')
}
